import React from "react";
import styled from "styled-components";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import { useNavigate } from "react-router-dom";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import PretendardText from "../../../component/atoms/text/pretendardText";
import EventBtn from "../../../component/atoms/button/eventBtn";
import MainInput from "./../../../component/atoms/input/mainInput";

const OperationConsult = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>상담 채널 연동</TableTitle>
          {/* 채널톡 */}
          <ConsultItemContainer
            style={{
              marginBottom: 8,
            }}
          >
            <ConsultItemTitleWrapper>
              <ConsultItemTitle>채널톡</ConsultItemTitle>
              <ConsultItemTitleDescription>
                채팅상담, 챗봇, 전화, CRM마케팅, 사내 메신저가 합쳐진 통합
                솔루션입니다.
                <br />
                AI와 챗봇으로 상담을 자동화하고, 실시간 상담과 마케팅 기능으로
                고객 이탈을 막고 구매를 유도합니다.
              </ConsultItemTitleDescription>
            </ConsultItemTitleWrapper>
            <ConsultDescriptionWrapper>
              <ConsultDescriptionText>
                신청절차
                <br />
                1. 채널톡 신규 가입하기
                <br />
                2. 채널톡 로그인 및 채널 선택하기
                <br />
                3. 스크립트 설치하기
              </ConsultDescriptionText>
            </ConsultDescriptionWrapper>
            <ConsultActiveWrapper>
              <ConsultAnchor
                href="https://channel.io/ko"
                target="_blank"
                rel="noreferrer"
              >
                채널톡 홈페이지로 이동
              </ConsultAnchor>
              <ConsultInputContainer>
                <ConsultInputWrapper>
                  <ConsultInputTitle>플러그인 키</ConsultInputTitle>
                  <MainInput
                    type={"text"}
                    placeholder={"-포함 문자열"}
                    style={{ width: "338px" }}
                    value={""}
                    onChange={() => {}}
                  />
                </ConsultInputWrapper>
                <ConsultInputWrapper>
                  <ConsultInputTitle>Access Secret</ConsultInputTitle>
                  <MainInput
                    type={"text"}
                    placeholder={"Channel Plugin Access Secret Key"}
                    style={{ width: "338px" }}
                    value={""}
                    onChange={() => {}}
                  />
                </ConsultInputWrapper>
                <EventBtn onClick={() => {}} text={"저장하기"} />
              </ConsultInputContainer>
            </ConsultActiveWrapper>
          </ConsultItemContainer>

          {/* 네이버 톡톡 */}
          <ConsultItemContainer
            style={{
              marginBottom: 8,
            }}
          >
            <ConsultItemTitleWrapper>
              <ConsultItemTitle>네이버 톡톡</ConsultItemTitle>
              <ConsultItemTitleDescription>
                PC, 모바일 어디서나 친구 추가 없이 고객과 실시간으로 상담을 할
                수 있습니다.
                <br />
                네이버 앱이나 SMS를 통해 모바일로도 알림을 받을 수 있습니다.
              </ConsultItemTitleDescription>
            </ConsultItemTitleWrapper>
            <ConsultDescriptionWrapper>
              <ConsultDescriptionText>
                신청절차
                <br />
                1. 네이버톡톡 사용신청
                <br />
                2. 네이버 톡톡을 내 사이트에 삽입하기
              </ConsultDescriptionText>
            </ConsultDescriptionWrapper>
            <ConsultActiveWrapper>
              <ConsultAnchor
                href="https://partner.talk.naver.com"
                target="_blank"
                rel="noreferrer"
              >
                네이버 톡톡 홈페이지로 이동
              </ConsultAnchor>
              <ConsultInputContainer>
                <ConsultInputWrapper>
                  <ConsultInputTitle>톡톡 data-id</ConsultInputTitle>
                  <MainInput
                    type={"text"}
                    placeholder={"id 숫자만 입력해주세요"}
                    style={{ width: "338px" }}
                    value={""}
                    onChange={() => {}}
                  />
                </ConsultInputWrapper>

                <EventBtn onClick={() => {}} text={"저장하기"} />
              </ConsultInputContainer>
            </ConsultActiveWrapper>
          </ConsultItemContainer>

          {/* 카카오톡 채널 */}
          <ConsultItemContainer>
            <ConsultItemTitleWrapper>
              <ConsultItemTitle>카카오톡 채널</ConsultItemTitle>
              <ConsultItemTitleDescription>
                PC, 모바일 어디서나 친구 추가 없이 고객과 실시간으로 상담을 할
                수 있습니다.
                <br />
                사용자가 카카오톡 채팅을 시작할 수 있도록 연결 페이지를
                제공합니다.
              </ConsultItemTitleDescription>
            </ConsultItemTitleWrapper>
            <ConsultDescriptionWrapper>
              <ConsultDescriptionText>
                신청절차
                <br />
                1. 카카오톡 채널 홈 ID 알아내기
                <br />
                2. 카카오 API 키 설정 및 알아내기
                <br />
                3. 내 사이트에 카카오톡 채널 적용하기
              </ConsultDescriptionText>
            </ConsultDescriptionWrapper>
            <ConsultActiveWrapper>
              <ConsultAnchor
                href="https://business.kakao.com/info/kakaotalkchannel"
                target="_blank"
                rel="noreferrer"
              >
                카카오톡 채널 홈페이지로 이동
              </ConsultAnchor>
              <ConsultInputContainer>
                <ConsultInputWrapper>
                  <ConsultInputTitle>채널 홈 ID</ConsultInputTitle>
                  <MainInput
                    type={"text"}
                    placeholder={"_로 시작되는 부분 입력"}
                    style={{ width: "338px" }}
                    value={""}
                    onChange={() => {}}
                  />
                </ConsultInputWrapper>
                <ConsultInputWrapper>
                  <ConsultInputTitle>API Key (JavaScript)</ConsultInputTitle>
                  <MainInput
                    type={"text"}
                    placeholder={
                      "카카오 개발자 센터에 복사한 JavaScript키 입력 "
                    }
                    style={{ width: "338px" }}
                    value={""}
                    onChange={() => {}}
                  />
                </ConsultInputWrapper>
                <EventBtn onClick={() => {}} text={"저장하기"} />
              </ConsultInputContainer>
            </ConsultActiveWrapper>
          </ConsultItemContainer>
        </DetailPageLayout>
      </MainLayout>
    </>
  );
};

export default OperationConsult;

const ConsultItemContainer = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  padding: 24px 0px;
  gap: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
`;

const ConsultItemTitleWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ConsultItemTitle = styled(PretendardText).attrs((props) => {})`
  font-weight: 600;
  font-size: 18px;
  line-height: 32.5px;
  letter-spacing: -0.3%;
  color: #27beff;
`;

const ConsultItemTitleDescription = styled(PretendardText).attrs((props) => {})`
  font-weight: 500;
  font-size: 13px;
  line-height: 18.75px;
  color: #aaa;
`;

const ConsultDescriptionWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
`;

const ConsultDescriptionText = styled(PretendardText).attrs((props) => {})`
  font-weight: 500;
  font-size: 13px;
  line-height: 18.75px;
  color: rgba(181, 181, 181, 0.5);
`;

const ConsultActiveWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
`;

const ConsultAnchor = styled.a.attrs((props) => {})`
  display: flex;
  width: fit-content;
  height: fit-content;
  padding: 8px 17.5px;
  align-items: center;
  justify-content: center;
  border-radius: 22px;
  background: #272829;
  font-family: "Pretendard";
  font-size: 15px;
  font-weight: 600;
  line-height: 24.5px;
  color: #aaa;
  cursor: pointer;
  margin-bottom: 30px;
`;

const ConsultInputContainer = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const ConsultInputWrapper = styled.div.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const ConsultInputTitle = styled(PretendardText).attrs((props) => {})`
  width: fit-content;
  height: fit-content;
  font-weight: 600;
  font-size: 14px;
  line-height: 22.75px;
  color: #aaa;
`;
